
import React from "react";
import { Users, Briefcase, BarChart3, CreditCard } from "lucide-react";
import { StrategyWithDetails, StrategyProvider } from "@/types/strategy-types";
import { formatDistanceToNow } from "date-fns";
import StatCard from "./StatCard";

interface StatCardsGridProps {
  users?: any[];
  strategies?: StrategyWithDetails[];
  providers?: StrategyProvider[];
  stripeSubscriptions?: {
    monthly: number;
    yearly: number;
    total: number;
    activeCanceled: number;
    subscriptions: any[];
  };
}

const StatCardsGrid: React.FC<StatCardsGridProps> = ({
  users,
  strategies,
  providers,
  stripeSubscriptions
}) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {/* Users Card */}
      <StatCard
        title="Total Users"
        value={users ? users.length : 0}
        subtitle={users && users.length > 0 && users[0].created_at 
          ? `Latest joined ${formatDistanceToNow(new Date(users[0].created_at))} ago`
          : "No users yet"}
        icon={Users}
      />
      
      {/* Strategy Providers Card */}
      <StatCard
        title="Strategy Providers"
        value={providers ? providers.length : 0}
        subtitle={providers && providers.length > 0 
          ? `${providers.filter(p => p.active).length} active providers`
          : "No providers yet"}
        icon={Briefcase}
      />
      
      {/* Strategies Card */}
      <StatCard
        title="Strategies"
        value={strategies ? strategies.length : 0}
        subtitle={strategies 
          ? `${strategies.filter(s => s.active).length} active, ${strategies.filter(s => s.approved).length} approved`
          : "No strategies yet"}
        icon={BarChart3}
      />
      
      {/* Subscriptions Card */}
      <StatCard
        title="Subscriptions"
        value={stripeSubscriptions ? stripeSubscriptions.total : 0}
        subtitle={stripeSubscriptions 
          ? `${stripeSubscriptions.monthly} monthly, ${stripeSubscriptions.yearly} yearly`
          : "No subscriptions yet"}
        icon={CreditCard}
      />
    </div>
  );
};

export default StatCardsGrid;
